import { useContext, useState, useEffect } from 'react';

import { IRoundGroup } from '../../../../../../store/admin/eventRounds/store';
import { GlobalContext } from '../../../../../../store';

import {
  useTeeSheetCreatorDispatch,
  useTeeSheetCreatorState
} from '../../Context/TeeSheetCreator.context';
import { useGetAdminEvent } from '../../../../../../contrib/Hooks/useGetAdminEvent';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { IOption } from '../../../../../../components/Select/Select';

export const useShotgunOptions = (group: IRoundGroup) => {
  const {
    actions: {
      adminGroups: { updateGroupShotgunSpot }
    }
  } = useContext(GlobalContext);

  const { shotgunSpots } = useTeeSheetCreatorState();
  const {
    actions: { disableShotgunSpot }
  } = useTeeSheetCreatorDispatch();

  const { clubId, eventId, roundId } = useRouteInfoState();

  const event = useGetAdminEvent(eventId);

  const [isShotgun, setIsShotgun] = useState(false);

  const [shotgunOptionsFormatted, setShotgunOptionsFormatted] = useState<IOption[]>();

  const [groupShotgunSpot, setGroupShotgunSpot] = useState<IOption>();

  useEffect(() => {
    if (event && event.rounds.length > 0) {
      setIsShotgun(event.rounds[0].shotgunStart);
    }
  }, [event]);

  useEffect(() => {
    if (group.startingHole !== null && group.startingHole !== undefined && group.startingPosition) {
      const { startingHole, startingPosition } = group;

      const label = `${Number(startingHole) + 1}${startingPosition.toUpperCase()}`;
      const value = `${Number(startingHole)}${startingPosition}`;

      setGroupShotgunSpot({
        label,
        value
      });
    }
  }, [group]);

  useEffect(() => {
    const options = shotgunSpots.map(spot => {
      const { startingHole, startingPosition } = spot;

      const label = `${Number(startingHole) + 1}${startingPosition.toUpperCase()}`;
      const value = `${Number(startingHole)}${startingPosition}`;

      return {
        label,
        value
      };
    });

    setShotgunOptionsFormatted(options);
  }, [shotgunSpots]);

  type TOnShotgunOptionSelected = (option: any) => Promise<void>;

  const onShotgunOptionSelected: TOnShotgunOptionSelected = async option => {
    if (clubId && eventId && roundId) {
      const data = {
        startingHole: Number(option.value[0]),
        startingPosition: option.value[1]
      };

      await updateGroupShotgunSpot(clubId, eventId, roundId, group.id, data);
      disableShotgunSpot(data).catch();
    }
  };

  return { onShotgunOptionSelected, shotgunOptionsFormatted, isShotgun, groupShotgunSpot };
};
